<template>
  <div
    class="w-72 max-lg:bg-white max-lg:hidden max-lg:min-h-screen max-lg:px-8 max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:z-50"
    :class="{ 'max-lg:!block': filterState }"
  >
    <div class="hidden mt-6 mb-10 max-lg:!flex max-lg:justify-between">
      <h2 class="text-xl font-bold">{{ $t('page.filter') }}</h2>
      <button
        @click="$emit('closeFilter', true)"
        class="absolute right-5 rounded p-1.5 bg-[#F8F8F8] hover:bg-[#F0F0F0] ease-linear transition-all duration-150"
      >
        <IconClose></IconClose>
      </button>
    </div>
    <div class="divide-y-2 overflow-y-auto max-lg:h-[90vh]">
      <div class="mb-4">
        <div class="overflow-y-scroll fltrs">
          <ul class="space-y-3 row-list">
            <li v-if="!hideFilters.includes('currentHasDiscount')">
              <div class="flex items-center justify-between gap-2 text-red-500">
                <p class="font-bold max-md:font-sm uppercase">{{ $t('page.discount') }}</p>
                <label for="has_discount" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="has_discount"
                    :checked="isTruthy(currentHasDiscount)"
                    @change="e => handleCheckbox(e, 'has_discount')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
            <li v-if="!hideFilters.includes('currentIsPromotion')">
              <div class="flex items-center justify-between gap-2 text-red-500">
                <p class="font-bold max-md:font-sm uppercase">{{ $t('page.promotion') }}</p>
                <label for="in_promotion" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="in_promotion"
                    :checked="isTruthy(currentIsPromotion)"
                    @change="e => handleCheckbox(e, 'in_promotion')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
            <li v-if="!hideFilters.includes('currentForCredit')">
              <div class="flex items-center justify-between gap-2">
                <p class="font-bold max-md:font-sm uppercase text-main-color">
                  {{ $t('page.onCredit') }}
                </p>
                <label for="for_credit" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="for_credit"
                    :checked="isTruthy(currentForCredit)"
                    @change="e => handleCheckbox(e, 'for_credit')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
            <li v-if="!hideFilters.includes('currentIsNew')">
              <div class="flex items-center justify-between gap-2 text-green-500">
                <p class="font-bold max-md:font-sm uppercase">{{ $t('page.new') }}</p>
                <label for="new" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="new"
                    :checked="isTruthy(currentIsNew)"
                    @change="e => handleCheckbox(e, 'is_new')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="!hideFilters.includes('currentCategory')" class="my-5 py-5">
        <p class="font-semibold text-xl mb-4">{{ $t('page.categories') }}</p>
        <div class="h-96 overflow-y-scroll fltrs">
          <ul class="space-y-3 row-list">
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentCategories == null }"
                :to="{
                  name: routeName,
                  query: {
                    is_vip: isVip,
                    ordering: currentSort,
                    price__range: priceQuery,
                    brand: currentBrands,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    for_credit: currentForCredit,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >{{ $t('page.all') }}</router-link
              >
            </li>
            <li v-for="category in $store.mallCategories" :key="category.id">
              <div class="flex items-center justify-between gap-5">
                <router-link
                  class="text-main-color text-base font-semibold hover:text-accent-color"
                  :class="{
                    '!text-accent-color': category.id == currentCategory || cat == category.id,
                  }"
                  :to="{
                    name: routeName,
                    query: {
                      categories: category.id,

                      is_vip: isVip,
                      ordering: currentSort,
                      price__range: priceQuery,
                      brand: currentBrands,
                      cat: category.id,
                      is_new: currentIsNew,
                      in_promotion: currentIsPromotion,
                      for_credit: currentForCredit,
                      has_discount: currentHasDiscount,
                      location: location,
                    },
                  }"
                  >{{ category.name }}
                  <span v-if="routeName == 'stores'" class="text-red-400 text-sm"
                    >({{ category.stores_count }})</span
                  >
                  <span v-else-if="routeName == 'products'" class="text-red-400 text-sm"
                    >({{ category.products_count }})</span
                  ></router-link
                >
                <div class="p-2" v-if="category.subcategories.length" @click="toggle(cat)">
                  <IconArrowLeft
                    :class="[cat == category.id ? 'rotate-0' : '-rotate-90']"
                    :id="`arrow-${cat}`"
                  />
                </div>
              </div>
              <ul
                v-if="cat == category.id"
                :id="`element-${cat}`"
                class="ml-3 space-y-3 mt-2 row-list font-normal"
              >
                <li v-for="subcategory in category.subcategories" :key="subcategory?.id">
                  <div class="flex items-center justify-between gap-5">
                    <router-link
                      class="font-normal text-main-color text-base hover:text-accent-color"
                      :class="{
                        '!text-accent-color':
                          subcategory.id == currentCategory || subcat == subcategory.id,
                      }"
                      :to="{
                        name: routeName,
                        query: {
                          categories: subcategory?.id,

                          is_vip: isVip,
                          ordering: currentSort,
                          price__range: priceQuery,
                          brand: currentBrands,
                          is_new: currentIsNew,
                          in_promotion: currentIsPromotion,
                          for_credit: currentForCredit,
                          has_discount: currentHasDiscount,
                          location: location,
                          cat: category.id,
                          subcat: subcategory.id,
                        },
                      }"
                    >
                      {{ subcategory?.name }}
                      <span v-if="routeName == 'stores'" class="text-red-400 text-sm"
                        >({{ subcategory.stores_count }})</span
                      >
                      <span v-else-if="routeName == 'products'" class="text-red-400 text-sm"
                        >({{ subcategory.products_count }})</span
                      ></router-link
                    >
                    <div
                      class="p-2"
                      v-if="subcategory.subcategories.length"
                      @click="toggle(subcat)"
                    >
                      <IconArrowLeft
                        :class="[subcat == subcategory.id ? 'rotate-0' : '-rotate-90']"
                        :id="`arrow-${subcat}`"
                      />
                    </div>
                  </div>
                  <ul
                    v-if="subcat == subcategory.id"
                    :id="`element-${subcat}`"
                    class="ml-3 space-y-3 mt-2 row-list font-normal"
                  >
                    <li
                      v-for="subsubcategory in subcategory.subcategories"
                      :key="subsubcategory?.id"
                    >
                      <router-link
                        class="font-normal text-main-color text-base hover:text-accent-color"
                        :class="{
                          '!text-accent-color': subsubcategory.id == currentCategory,
                        }"
                        :to="{
                          name: routeName,
                          query: {
                            categories: subsubcategory?.id,

                            is_vip: isVip,
                            ordering: currentSort,
                            price__range: priceQuery,
                            brand: currentBrands,

                            is_new: currentIsNew,
                            in_promotion: currentIsPromotion,
                            for_credit: currentForCredit,
                            has_discount: currentHasDiscount,
                            location: location,
                            cat: category.id,
                            subcat: subcategory.id,
                            subsubcat: subsubcategory.id,
                          },
                        }"
                      >
                        {{ subsubcategory?.name }}
                        <span v-if="routeName == 'stores'" class="text-red-400 text-sm"
                          >({{ subsubcategory.stores_count }})</span
                        >
                        <span v-else-if="routeName == 'products'" class="text-red-400 text-sm"
                          >({{ subsubcategory.products_count }})</span
                        ></router-link
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="!hideFilters.includes('currentBrands')" class="my-5 py-5">
        <p class="font-semibold text-xl mb-4">{{ $t('nav.brands') }}</p>
        <div class="h-72 overflow-y-scroll fltrs">
          <ul class="space-y-3 row-list">
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentCategory == null }"
                :to="{
                  name: routeName,
                  query: {
                    categories: currentCategory,

                    is_vip: isVip,
                    ordering: currentSort,

                    price__range: priceQuery,
                    brand: null,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    for_credit: currentForCredit,
                    has_discount: currentHasDiscount,
                    location: location,
                    cat: cat,
                    subcat: subcat,
                    subsubcat: subsubcat,
                  },
                }"
                >{{ $t('page.all') }}</router-link
              >
            </li>
            <li v-for="brand in brands" :key="brand.id">
              <div class="flex items-center justify-between">
                <div class="flex gap-1">
                  {{ brand.name
                  }}<span class="text-red-400 text-sm">({{ brand.products__count }})</span>
                </div>
                <input
                  @change="brandChecked"
                  :value="brand.id"
                  type="checkbox"
                  :checked="normalizedCurrentBrands.includes(brand.id.toString())"
                />
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="!hideFilters.includes('currentPrice')" class="my-5 py-5">
        <p class="font-semibold">{{ $t('page.price') }}</p>
        <div class="mt-5">
          <!-- <Slider @change="handlePriceSlider" class="px-1" showTooltip="drag" :max="maxPrice"
              v-model="sli" /> -->
          <div class="flex gap-7 mt-5">
            <div class="flex flex-col">
              <label for="minPrice">{{ $t('page.min') }}</label>
              <input
                v-model.number="minPriceQuery"
                @input="debouncedOnChange"
                class="w-full font-medium text-sm py-1 px-3 rounded border border-solid border-gp-grey-90"
                type="number"
                name="minPrice"
                min="0"
                id="minPrice"
              />
            </div>
            <div class="flex flex-col">
              <label for="minPrice">{{ $t('page.max') }}</label>

              <input
                v-model.number="maxPriceQuery"
                @input="debouncedOnChange"
                class="w-full font-medium text-sm py-1 px-3 rounded border border-solid border-gp-grey-90"
                type="number"
                name="maxPrice"
                id="maxPrice"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="my-3 py-3">
        <button
          @click="clearFilter"
          class="bg-accent-color w-full py-2 rounded-md text-white hover:bg-main-color"
        >
          {{ $t('page.clear') }}
        </button>
      </div>
    </div>
  </div>
  <div
    class="fixed inset-0 hidden bg-gray-800 bg-opacity-50"
    :class="{ 'max-lg:!flex': filterState }"
  ></div>
</template>

<script>
import _debounce from 'lodash.debounce';
import IconArrowLeft from '@icons/IconArrowLeft.vue';
import IconClose from '@icons/IconClose.vue';
export default {
  name: 'MallSide',
  components: {
    IconArrowLeft,
    IconClose,
  },
  props: {
    routeName: {
      type: String,
      default: 'stores',
    },
    filterState: {
      type: Boolean,
      default: false,
    },
    brands: {
      type: Array,
      default: () => [],
    },
    hideFilters: {
      type: Array,
      default: () => [],
      required: false,
    },
    currentCategories: {
      type: [Number, String],
      default: undefined,
    },

    currentBrands: {
      type: [Array, String],
      default: undefined,
    },
    isVip: {
      type: [Boolean, String],
      default: undefined,
    },
    currentPrice: {
      type: [Number, String],
      default: undefined,
    },
    currentIsNew: {
      type: [Boolean, String],
      default: undefined,
    },
    currentIsPromotion: {
      type: [Boolean, String],
      default: undefined,
    },
    currentForCredit: {
      type: [Boolean, String],
      default: undefined,
    },
    currentHasDiscount: {
      type: [Boolean, String],
      default: undefined,
    },
    currentSort: {
      type: [Number, String],
      default: undefined,
    },
    cat: {
      type: [Number, String],
      default: undefined,
    },
    subcat: {
      type: [Number, String],
      default: undefined,
    },
    subsubcat: {
      type: [Number, String],
      default: undefined,
    },
    location: {
      type: [Number, String],
      default: undefined,
    },
  },
  watch: {
    currentPrice: {
      //   immediate: true,
      async handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (this.currentPrice) {
            let x = this.currentPrice.split('__');
            this.minPriceQuery = x[0];
            if (x.length > 1) {
              this.maxPriceQuery = x[1];
            }
          } else {
            this.minPriceQuery = null;
            this.maxPriceQuery = null;
            this.priceQuery = undefined;
          }
        }
      },
    },
  },
  data() {
    return {
      minPriceQuery: null,
      maxPriceQuery: null,
      priceQuery: undefined,
      brandChekboxes: [],
    };
  },

  methods: {
    toggle(id) {
      try {
        let element = document.getElementById(`element-${id}`);
        let arrow = document.getElementById(`arrow-${id}`);
        if (element.classList.contains('hidden')) {
          element.classList.remove('hidden');
          arrow.classList.remove('-rotate-90');
          arrow.classList.add('rotate-0');
        } else {
          element.classList.add('hidden');
          arrow.classList.remove('rotate-0');
          arrow.classList.add('-rotate-90');
        }
      } catch (e) {}
    },
    brandChecked(event) {
      let value = event.target.value;
      if (event.target.checked) {
        this.brandChekboxes.push(value);
      } else {
        const index = this.brandChekboxes.indexOf(value);
        this.brandChekboxes.splice(index, 1);
      }
      this.$router.push({
        name: this.routeName,
        query: {
          categories: this.currentCategory,
          is_vip: this.isVip,
          price__range: this.priceQuery,
          ordering: this.currentSort,
          brand: this.brandChekboxes,
          is_new: this.currentIsNew,
          in_promotion: this.currentIsPromotion,
          for_credit: this.currentForCredit,
          has_discount: this.currentHasDiscount,
          cat: this.cat,
          subcat: this.subcat,
          subsubcat: this.subsubcat,
          location: this.location,
        },
      });
    },
    isTruthy(value) {
      return value === true || value === 'true' || value === 1 || value === '1';
    },

    cleanQuery(query) {
      Object.keys(query).forEach(key => {
        const value = query[key];

        if (
          value === undefined ||
          value === null ||
          value === '' ||
          value === false ||
          value === 'false' ||
          (Array.isArray(value) && value.length === 0)
        ) {
          delete query[key];
        }
      });

      return query;
    },

    clearFilter() {
      this.minPriceQuery = null;
      this.maxPriceQuery = null;
      this.priceQuery = undefined;
      this.brandChekboxes = [];

      this.$router.push({
        name: this.routeName,
        query: {},
      });
    },

    handleCheckbox(e, name) {
      const query = this.cleanQuery({
        categories: this.currentCategory,
        is_vip: this.isVip,
        price__range: this.priceQuery || this.currentPrice,
        ordering: this.currentSort,
        brand: this.currentBrands,
        is_new: this.currentIsNew,
        in_promotion: this.currentIsPromotion,
        for_credit: this.currentForCredit,
        has_discount: this.currentHasDiscount,
        cat: this.cat,
        subcat: this.subcat,
        subsubcat: this.subsubcat,
        location: this.location,
      });

      if (e.target.checked) {
        query[name] = true;
      } else {
        delete query[name];
      }

      this.$router.push({
        name: this.routeName,
        query,
      });
    },
    pushChanges() {
      if (this.minPriceQuery < 0 || this.minPriceQuery == null || this.minPriceQuery == '') {
        this.minPriceQuery = 0;
      }
      this.priceQuery = `${this.minPriceQuery}__${this.maxPriceQuery}`;
      if (!this.maxPriceQuery) {
        this.priceQuery = `${this.minPriceQuery}`;
      }
      this.$router.push({
        name: this.routeName,
        query: {
          categories: this.currentCategory,
          is_vip: this.isVip,
          price__range: this.priceQuery,
          ordering: this.currentSort,
          brand: this.currentBrands,
          is_new: this.currentIsNew,
          in_promotion: this.currentIsPromotion,
          for_credit: this.currentForCredit,
          has_discount: this.currentHasDiscount,
          cat: this.cat,
          subcat: this.subcat,
          subsubcat: this.subsubcat,
          location: this.location,
        },
      });
    },
  },
  mounted() {
    this.brandChekboxes = [...this.normalizedCurrentBrands];
  },
  computed: {
    currentCategory() {
      return this.currentCategories;
    },

    normalizedCurrentBrands() {
      if (Array.isArray(this.currentBrands)) {
        return this.currentBrands.map(String);
      }

      if (this.currentBrands) {
        return [String(this.currentBrands)];
      }

      return [];
    },

    debouncedOnChange() {
      return _debounce(this.pushChanges, 500);
    },
  },
};
</script>
